import {
  IInsuranceCoverage,
  IInsuranceCoverageListRequestFilter,
  IInsuranceCoverageListRequestSort
} from "./types";
import { insuranceCoverageService } from "./service";
import { ListRequestQuery } from "../../../../utils/serviceHelper";

export const getInsuranceCoverages = async (
  query?: ListRequestQuery<
    IInsuranceCoverageListRequestFilter,
    IInsuranceCoverageListRequestSort
  >
): Promise<IInsuranceCoverage[]> => {
  const { data } = await insuranceCoverageService.get<IInsuranceCoverage[]>(
    `/`,
    {
      params: query
    }
  );

  return data;
};
